import { Navigate, Route, Routes } from 'react-router-dom';

import { useAdminAuth } from './auth/AuthProvider';
import { Nav } from './components/Nav';
import { ContractDetailPage } from './routes/ContractDetailPage';
import { ContractsPage } from './routes/ContractsPage';
import { LoginPage } from './routes/LoginPage';
import { SystemHealthPage } from './routes/SystemHealthPage';
import { TenantDetailPage } from './routes/TenantDetailPage';
import { TenantsPage } from './routes/TenantsPage';
import { WebhookHealthPage } from './routes/WebhookHealthPage';

export function App() {
  const auth = useAdminAuth();
  if (!auth.jwt) {
    return <LoginPage />;
  }
  return (
    <div className="min-h-screen">
      <Nav />
      <main className="mx-auto max-w-6xl space-y-4 p-4">
        <Routes>
          <Route path="/" element={<Navigate to="/tenants" replace />} />
          <Route path="/tenants" element={<TenantsPage />} />
          <Route path="/tenants/:id" element={<TenantDetailPage />} />
          <Route path="/contracts" element={<ContractsPage />} />
          <Route path="/contracts/:id" element={<ContractDetailPage />} />
          <Route path="/health/webhooks" element={<WebhookHealthPage />} />
          <Route path="/health/system" element={<SystemHealthPage />} />
          <Route path="*" element={<Navigate to="/tenants" replace />} />
        </Routes>
      </main>
    </div>
  );
}
